import React, { useEffect, useState } from "react";
import { calculateBMIFromKgInchValue, startLoader, stopLoader } from "../../../lib/utils";
// import config from "../../../config";
import client from "../../../clients";
import { updateAppointment } from "../helper/api";
import { isAuthenticated } from "../../../auth";
import Toast from "../../../lib/toast";
import { getAllMembers } from "../../member/helper/api";

const MarkAppointmentReport = (props) => {

  const [currentElementId, setCurrentElementId] = useState("report-comment");
  const [isButtonLock,setButtonLock] = useState(false);

  const [userReport, setUserReport] = useState({
    reportComment: "",
    bodyComposition: {
      weight: {
        value: "",
        unit: "Kg"
      },
      height: "",
      bmi: {
        value: "",
        type: ""
      },
      userReportImage: [],
      fitnessMeasurement: {
        docs: "",
        currentMeasurement: {},
        goalMeasurement: {}
      }
    },
    fitnessTest: {
      docs: "",
      fitnessPlanner: {
        plannerName: "",
        tests: []
      }
    },
    nutrition: {
      assignedNutritionPlannerId: ""
    }
  })

  const [measurement, setMeasurement] = useState({
    chest: "",
    thighCircumference: "",
    midArmCircumference: "",
    upperArmCircumference: "",
    foreArmCircumference: "",
    waist: ""
  });

   const [selectedUserAppointment, setSelectedUserAppointment] = useState([
      // sample
      // {
      //   userInfo: {
      //     name:"Test User",
      //     phone:"+91 83737373737"
      //   }
      // }
      ]);

  const [fitnessPlanners, setFitnessPlanners] = useState([
    {
      name: "Fitness Planner 1",
      exercisesTest: [
        {
          name: "Push Ups",
          unit: "Reps"
        },
        {
          name: "Squats",
          unit: "Reps"
        },
        {
          name: "Dumble Bench Press",
          unit: "Weight",
          value: "" 
        }
      ]
    },
    {
      name: "Fitness Planner 2",
      exercisesTest: [
        {
          name: "How to do Push Ups with proper co-ordination",
          unit: "Reps"
        },
        {
          name: "Squats",
          unit: "Reps"
        },
        {
          name: "Dumble Bench Press",
          unit: "Weight"
        }
      ]
    },
    {
      name: "Fitness Planner 3",
      exercisesTest: [
        {
          name: "How to do Push Ups with proper co-ordination",
          unit: "Reps"
        },
        {
          name: "Squats",
          unit: "Reps"
        },
        {
          name: "Dumble Bench Press",
          unit: "Weight"
        }
      ]
    }
  ]);

  const [currentFitnessPlannerIndex, setCurrentFitnessPlannerIndex] = useState(0); 
  const [fitnessPlannerDetails, setFitnessPlannerDetails] = useState({
    testName: "",
    testUnit: {
      type : "",
      value : "",
    },
    achievement: "",
    goal: "",
  });

  const [currentNutritionPlanner, setCurrentNutritionPlanner] = useState({});
  const [nutritionPlanners, setNutritionPlanners] = useState([]);
  const {user,token} = isAuthenticated();
  


   const getAppointmentBookedCount = async () =>{
          if(props.appointmentDetails && props.appointmentDetails.extendedProps && props.appointmentDetails.extendedProps.memberIDs){
          const params = {
              ids:props.appointmentDetails.extendedProps.memberIDs
          }
          const response = await getAllMembers(user._id,token,params);
          if(!response.error){
              setSelectedUserAppointment(response);
          }
          }
      }

  const MarkAppointment = async event =>{
     try{
      await startLoader();
      setButtonLock(true)
      const payload = {
        status:"completed",
        appointmentSlotId:props.appointmentDetails.extendedProps.appointmentSlotId,
        remark:userReport.reportComment
      };

      const response = await updateAppointment(user._id,token,props.appointmentDetails.extendedProps.appointmentId,payload);
      if(response.error){
        new Toast({
          type:"error",
          message:response.error,
          duration:3000
        })
      }else{
        new Toast({
          type:"success",
          message:"Appointment marked successfully",
          duration:3000
        })
        props.updateCalendarSlot({appointmentDetails:props.appointmentDetails,appointment:response,action:"completed"});
        props.handleCloseReportModal();
      }

      await stopLoader();
     }catch(error){
      await stopLoader();
     }
     setButtonLock(false);
  }


  const toggleInputFields = (id) => event => {
    setCurrentElementId(id);
    if (event) {
      let interval = setInterval(() => {
        let element = event.target.querySelector('input');
        if (element) {
            element.focus();
            clearInterval(interval)
        }
      }, 0);
    }
  }

  const handleChange = (keyName, value) => async event => {
    const finalValue = value ?? event.target.value;
  
    if (keyName === "weight-value") {
      setUserReport(prev => ({
        ...prev,
        bodyComposition: {
          ...prev.bodyComposition,
          weight: {
            ...prev.bodyComposition.weight,
            value: finalValue
          }
        }
      }));
    } else if (keyName === "height") {
      setUserReport(prev => ({
        ...prev,
        bodyComposition: {
          ...prev.bodyComposition,
          height: finalValue
        }
      }));
    } else if (keyName === "chest-current") {
      setUserReport(prev => ({
        ...prev,
        bodyComposition: {
          ...prev.bodyComposition,
          fitnessMeasurement: {
            ...prev.bodyComposition.fitnessMeasurement,
            currentMeasurement: {
              ...prev.bodyComposition.fitnessMeasurement.currentMeasurement,
              chest: finalValue
            }
          }
        }
      }));
    }  else if (keyName === "chest-target") {
      setUserReport(prev => ({
        ...prev,
        bodyComposition: {
          ...prev.bodyComposition,
          fitnessMeasurement: {
            ...prev.bodyComposition.fitnessMeasurement,
            goalMeasurement: {
              ...prev.bodyComposition.fitnessMeasurement.goalMeasurement,
              chest: finalValue
            }
          }
        }
      }));
    } else if (keyName == "thigh-circumference-current") {
      setUserReport(prev => ({
        ...prev,
        bodyComposition: {
          ...prev.bodyComposition,
          fitnessMeasurement: {
            ...prev.bodyComposition.fitnessMeasurement,
            currentMeasurement: {
              ...prev.bodyComposition.fitnessMeasurement.currentMeasurement,
              thigh: finalValue
            }
          }
        }
      }));
    } else if (keyName == "thigh-circumference-target") {
      setUserReport(prev => ({
        ...prev,
        bodyComposition: {
          ...prev.bodyComposition,
          fitnessMeasurement: {
            ...prev.bodyComposition.fitnessMeasurement,
            goalMeasurement: {
              ...prev.bodyComposition.fitnessMeasurement.goalMeasurement,
              thigh: finalValue
            }
          }
        }
      }));
    } else if (keyName == "midArm-circumference-current"){
      setUserReport(prev => ({
        ...prev,
        bodyComposition: {
          ...prev.bodyComposition,
          fitnessMeasurement: {
            ...prev.bodyComposition.fitnessMeasurement,
            currentMeasurement: {
              ...prev.bodyComposition.fitnessMeasurement.currentMeasurement,
              midArm: finalValue
            }
          }
        }
      }));
    } else if (keyName == "midArm-circumference-target"){
      setUserReport(prev => ({
        ...prev,
        bodyComposition: {
          ...prev.bodyComposition,
          fitnessMeasurement: {
            ...prev.bodyComposition.fitnessMeasurement,
            goalMeasurement: {
              ...prev.bodyComposition.fitnessMeasurement.goalMeasurement,
              midArm: finalValue
            }
          }
        }
      }));
    } else if (keyName == "foreArm-circumference-current"){
      setUserReport(prev => ({
        ...prev,
        bodyComposition: {
          ...prev.bodyComposition,
          fitnessMeasurement: {
            ...prev.bodyComposition.fitnessMeasurement,
            currentMeasurement: {
              ...prev.bodyComposition.fitnessMeasurement.currentMeasurement,
              foreArm: finalValue
            }
          }
        }
      }));
    } else if (keyName == "foreArm-circumference-target"){
      setUserReport(prev => ({
        ...prev,
        bodyComposition: {
          ...prev.bodyComposition,
          fitnessMeasurement: {
            ...prev.bodyComposition.fitnessMeasurement,
            goalMeasurement: {
              ...prev.bodyComposition.fitnessMeasurement.goalMeasurement,
              foreArm: finalValue
            }
          }
        }
      }));
    } else if (keyName == "upperArm-circumference-current"){
      setUserReport(prev => ({
        ...prev,
        bodyComposition: {
          ...prev.bodyComposition,
          fitnessMeasurement: {
            ...prev.bodyComposition.fitnessMeasurement,
            currentMeasurement: {
              ...prev.bodyComposition.fitnessMeasurement.currentMeasurement,
              upperArm: finalValue
            }
          }
        }
      }));
    } else if (keyName == "upperArm-circumference-target"){
      setUserReport(prev => ({
        ...prev,
        bodyComposition: {
          ...prev.bodyComposition,
          fitnessMeasurement: {
            ...prev.bodyComposition.fitnessMeasurement,
            goalMeasurement: {
              ...prev.bodyComposition.fitnessMeasurement.goalMeasurement,
              upperArm: finalValue
            }
          }
        }
      }));
    } else if (keyName == "waist-circumference-current"){
      setUserReport(prev => ({
        ...prev,
        bodyComposition: {
          ...prev.bodyComposition,
          fitnessMeasurement: {
            ...prev.bodyComposition.fitnessMeasurement,
            currentMeasurement: {
              ...prev.bodyComposition.fitnessMeasurement.currentMeasurement,
              waist: finalValue
            }
          }
        }
      }));
    } else if (keyName == "waist-circumference-target"){
      setUserReport(prev => ({
        ...prev,
        bodyComposition: {
          ...prev.bodyComposition,
          fitnessMeasurement: {
            ...prev.bodyComposition.fitnessMeasurement,
            goalMeasurement: {
              ...prev.bodyComposition.fitnessMeasurement.goalMeasurement,
              waist: finalValue
            }
          }
        }
      }));
    } else {
      setUserReport(prev => ({
        ...prev,
        [keyName]: finalValue
      }));
    }
  };
  

  const handleChangeWeightUnit = (unit) => {
    setUserReport({
      ...userReport,
      bodyComposition : {
        ...userReport.bodyComposition,
        weight : {
          ...userReport.bodyComposition.weight,
          unit : unit
        }
      }    
    })
  }

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);

    const userImage = files.map((file) => {
      return URL.createObjectURL(file);
    });

    setUserReport((prev) => ({
      ...prev,
      bodyComposition: {
        ...prev.bodyComposition,
        userReportImage: userImage
      }
    }));
  };

  const handleDeleteSelectedReportImage = (index) => {
    setUserReport((prev) => ({
      ...prev,
      bodyComposition: {
        ...prev.bodyComposition,
        userReportImage: prev.bodyComposition.userReportImage.filter((_, i) => i !== index)
      }
    }));
  }

  const handleFitnessPlanner = (index) => {
    setCurrentFitnessPlannerIndex(currentFitnessPlannerIndex != index ? index : -1);
  }

  const handleFitnessTakeTest = (fitnessPlanner) => {
    const modifiedExercises = fitnessPlanner.exercisesTest.map(exercise => ({
      ...exercise,
      achievement: "",
      goal: ""
    }));
  
    // Push into the tests array
    setUserReport(prev => ({
      ...prev,
      fitnessTest: {
        ...prev.fitnessTest,
        fitnessPlanner: {
          ...prev.fitnessTest.fitnessPlanner,
          plannerName: fitnessPlanner.name,
          tests: [
            ...prev.fitnessTest.fitnessPlanner.tests,
            ...modifiedExercises
          ]
        }
      }
    }));
  }

  const handleCancelFitnessPlanner = () => {
    setUserReport(prev => ({
      ...prev,
      fitnessTest: {
        ...prev.fitnessTest,
        fitnessPlanner: {
          plannerName: "",
          tests: []
        }
      }
    }));
  }

  const getAppointmentMembers = () =>{
    let result = {};
    let members = [...selectedUserAppointment];

    let memberlist =  members.slice(0, 3);
    let remainingCount = members.length - 3;

    if(remainingCount > 0){
      result={
        memberlist,
        remainingCount
      }
    }else{
      result = {
        memberlist
      }
    }

    return result;

  }

  useEffect(() => {
    const { bmi, status } = calculateBMIFromKgInchValue(
      userReport.bodyComposition.weight.value,
      userReport.bodyComposition.height
    );
  
    setUserReport(prev => ({
      ...prev,
      bodyComposition: {
        ...prev.bodyComposition,
        bmi: {
          value: bmi,
          type: status
        }
      }
    }));
  }, [
    userReport.bodyComposition.weight.value,
    userReport.bodyComposition.height
  ]);

  useEffect(async ()=>{
    try{
      await startLoader()
      await getAppointmentBookedCount()
      await stopLoader()
    }catch(error){
      await stopLoader()
    }
  },[props]);


  return(
    <div className={window.innerWidth < 768 ? "w-full h-full" : "global-modal-container d-flex"}>
      <div className={window.innerWidth < 768 ? "w-full h-full" : "global-modal-type-2 mark-appointment-modal flex-item"}>
        {
          window.innerWidth > 767 && (
            <div className="d-flex w-full space-between" style={{background: "#DEF3FF", padding:"12px", borderRadius: "16px 16px 0 0"}}>
              <div className="d-flex cursor-pointer">
                {
                  getAppointmentMembers().memberlist && (
                    <>
                    
                       {
                          getAppointmentMembers().memberlist.length == 1 ? (
                            <>
                                <div className="user-profile d-flex  m-r-12">
                                {
                                 getAppointmentMembers().memberlist[0].user[0].profileID ? (
                                      <img className="table-item-profile d-flex flex-item" src={`${client.config.API_URL}/image/file/${props.appointmentDetails.extendedProps.user.profileID}/auto/auto/70?${Date.now()}`} />
                                    ) : (
                                      <div className="table-item-profile d-flex flex-item" style={{
                                        backgroundColor: '#5d883c'
                                      }}>
                                        <p className='flex-item margin-auto' style={{ color: '#ffffff', fontSize: 14, margin: '0 auto' }}>{`${getAppointmentMembers().memberlist[0].user[0].name}`.trim()[0]}</p>
                                      </div>
                                    )
                                }
                                {/* <img className="flex-item profile-img" src={`https://picsum.photos/id/1/200/300`} /> */}
                                {/* {
                                  props.appointmentDetails.extendedProps.user.outsider && (
                                    <svg className="flex-item outsider-badge" width="16" height="16" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <circle cx="6" cy="6" r="6" fill="#FF0000"/>
                                      <path d="M5.52447 3.46352C5.67415 3.00287 6.32585 3.00287 6.47553 3.46353L6.7858 4.41844C6.85274 4.62445 7.04471 4.76393 7.26133 4.76393H8.26539C8.74975 4.76393 8.95113 5.38374 8.55928 5.66844L7.74698 6.25861C7.57173 6.38593 7.4984 6.61162 7.56534 6.81763L7.87561 7.77254C8.02529 8.2332 7.49805 8.61626 7.10619 8.33156L6.29389 7.74139C6.11865 7.61407 5.88135 7.61407 5.70611 7.74139L4.89381 8.33156C4.50195 8.61626 3.97471 8.2332 4.12439 7.77254L4.43466 6.81763C4.5016 6.61162 4.42827 6.38593 4.25302 6.25861L3.44072 5.66844C3.04887 5.38374 3.25025 4.76393 3.73462 4.76393H4.73867C4.95529 4.76393 5.14726 4.62445 5.2142 4.41844L5.52447 3.46352Z" fill="white"/>
                                    </svg>
                                  )
                                } */}
                              </div>
                              <div className="flex-item">
                                <p className="flex-item fs-20 font-weight-700" style={{lineHeight:'20px'}}>{getAppointmentMembers().memberlist[0].user[0].name}</p>
                                <p className="flex-item fs-12 m-t-3" style={{lineHeight:'12px'}}>{getAppointmentMembers().memberlist[0].gym.length >0 ? getAppointmentMembers().memberlist[0].gym[0].name : ""}</p>
                              </div>
                            </>
                          ):(
                            <>

                             {
                                getAppointmentMembers().memberlist && getAppointmentMembers().memberlist.map(member => {
                                  return(
                                    <div className="d-flex" style={{position:"relative"}}>
                                      {
                                        member.user[0].profileID ? (
                                          <div className="user-info-image d-flex flex-item" style={{border:"2px solid #ffffff", boxShadow:"0px 0px 4px rgba(0,0,0,0.25)", marginLeft:"-20px" }}>
                                            <img className="flex-item" src={`${client.config.API_URL}/image/file/${member.user[0].profileID}/auto/auto/70?${Date.now()}`} />
                                            </div>
                                          ) : (
                                            <div className="user-info-image d-flex flex-item" style={{border:"2px solid #ffffff", boxShadow:"0px 0px 4px rgba(0,0,0,0.25)", marginLeft:"-10px", backgroundColor: '#5d883c'}}>
                                              <p className='flex-item margin-auto' style={{ color: '#ffffff', fontSize: 14, margin: '0 auto' }}>{`${member.user[0].name}`.trim()[0]}</p>
                                            </div>
                                          )
                                      }
                                    </div>
                                  )
                                })
                              }

                              {
                                getAppointmentMembers().remainingCount && (
                                  <p className="color-dark-blue font-weight-700 fs-16 flex-item m-l-12">+{getAppointmentMembers().remainingCount} Members</p>
                                )
                              }


                            </>
                          )
                       }
                    
                    </>
                  )
                }
              {/* {
                     props.appointmentDetails.extendedProps.user.profileID ? (
                      <div className="user-profile d-flex  m-r-12">
                        <img className="flex-item profile-img" src={`${config.API_URL}/image/file/${props.appointmentDetails.extendedProps.user.profileID}/auto/auto/70?${Date.now()}`} />
                      </div>
                      ) : (
                        <div className="user-profile d-flex  m-r-12" style={{
                          backgroundColor: props.appointmentDetails.extendedProps.user.profilePlaceHolderColor ? props.appointmentDetails.extendedProps.user.profilePlaceHolderColor : '#5d883c'
                        }}>
                          <p className='flex-item margin-auto' style={{ color: '#ffffff', fontSize: 14, margin: '0 auto' }}>{`${props.appointmentDetails.extendedProps.user.name}`.trim()[0]}</p>
                        </div>
                      )
                  } */}
          
              </div>
              <div onClick={()=>props.handleCloseModal("choose-action")} className="d-flex desktop-modal-close-button" style={{width: "30px", height:"30px", background:"#f9f9f9"}}>
                <svg className="flex-item" width="24" height="24" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4.9283 3.80866C4.77899 3.66445 4.57901 3.58465 4.37144 3.58646C4.16387 3.58826 3.96531 3.67152 3.81853 3.8183C3.67175 3.96508 3.58849 4.16364 3.58668 4.37121C3.58488 4.57879 3.66468 4.77876 3.80888 4.92807L8.38076 9.49995L3.80809 14.0718C3.73248 14.1449 3.67217 14.2322 3.63068 14.3288C3.58919 14.4254 3.56735 14.5293 3.56644 14.6344C3.56552 14.7395 3.58555 14.8437 3.62536 14.941C3.66516 15.0383 3.72395 15.1267 3.79828 15.2011C3.87261 15.2754 3.961 15.3342 4.0583 15.374C4.15559 15.4138 4.25983 15.4338 4.36495 15.4329C4.47007 15.432 4.57395 15.4101 4.67054 15.3687C4.76712 15.3272 4.85448 15.2669 4.92751 15.1912L9.50018 10.6194L14.0721 15.1912C14.2214 15.3354 14.4213 15.4152 14.6289 15.4134C14.8365 15.4116 15.035 15.3284 15.1818 15.1816C15.3286 15.0348 15.4119 14.8363 15.4137 14.6287C15.4155 14.4211 15.3357 14.2211 15.1915 14.0718L10.6196 9.49995L15.1915 4.92807C15.3357 4.77876 15.4155 4.57879 15.4137 4.37121C15.4119 4.16364 15.3286 3.96508 15.1818 3.8183C15.035 3.67152 14.8365 3.58826 14.6289 3.58646C14.4213 3.58465 14.2214 3.66445 14.0721 3.80866L9.50018 8.38053L4.9283 3.80786V3.80866Z" fill="black" />
                </svg>
              </div>
            </div>
          )
        }
        <div className='w-full m-t-4' style={{padding:"8px 12px 12px 12px", height: window.innerWidth < 768 ? "90%" : "81%", overflowY:"auto"}}>
          <div className="d-flex space-between w-full">
            <p className="flex-item m-r-8 font-weight-700 color-dark-blue fs-18" style={{lineHeight:"18px"}}>{props.appointmentDetails.extendedProps && props.appointmentDetails.extendedProps.formatDateString} - {props.appointmentDetails.extendedProps.slotStartTime.hr}:{props.appointmentDetails.extendedProps.slotStartTime.min} {props.appointmentDetails.extendedProps.slotStartTime.period}</p>
            <div className="d-flex">
              <div className="apt-tag">
                <p className="fs-14 color-blue font-weight-600">{props.appointmentDetails.extendedProps.reportType}</p>
              </div>
              <div className="apt-tag-head"/>
            </div>
          </div>
          <div onClick={toggleInputFields('report-comment')} className={`${(currentElementId == "report-comment" || userReport.reportComment) ? "member-global-input-field m-t-20 m-b-16 flex-item" : "member-global-input-field m-t-20 m-b-16 flex-item d-flex"}`} style={{ border: (currentElementId == "report-comment" || userReport.reportComment) ? "1px solid var(--darkBlue)" : "", height:'120px' }}>
            <p className="placeholder-txt m-t-3" style={{ fontSize: (currentElementId == "report-comment" || userReport.reportComment) ? "10px" : "14px", color: (currentElementId == "report-comment" || userReport.reportComment) ? "var(--darkBlue)" : "", transition: "180ms", alignSelf:"flex-start" }}>Report</p>
            <textarea style={{width:"94%", height:"86px"}} onChange={handleChange("reportComment")} value={userReport.reportComment} id="report-comment" className={`${(currentElementId == "report-comment" || userReport.reportComment) ? "active-input-field" : "inactive-input-field"}`} type="text" />
          </div>

          {/* {
            props.appointmentDetails.extendedProps.reportType == "Body Composition" && (
              <div className="w-full">
                <div className="d-flex m-b-8 m-t-12">
                  <p className="flex-item m-r-8 font-weight-700 fs-16">BMI</p>
                  {userReport.bodyComposition.weight.value && userReport.bodyComposition.height && (
                    <p className="flex-item fs-16"><span className="font-weight-700 color-red">{userReport.bodyComposition.bmi.value}</span> - {userReport.bodyComposition.bmi.type}</p>
                  )}
                </div>
                <div className="d-flex space-between w-full">
                  <div onClick={toggleInputFields('weight')} className={`${(currentElementId == 'weight' || userReport.bodyComposition.weight.value) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: (currentElementId == 'weight' || userReport.bodyComposition.weight.value) ? "1px solid var(--darkBlue)" : "", width: "48%" }}>
                    <div className="flex-item d-flex">
                      <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'weight' || userReport.bodyComposition.weight.value) ? "10px" : "14px", color: (currentElementId == 'weight' || userReport.bodyComposition.weight.value) ? "var(--darkBlue)" : "", transition: "180ms" }}>Weight ({userReport.bodyComposition.weight.unit})</p>
                    </div>
                    <div className={`${(currentElementId == 'weight' || userReport.bodyComposition.weight.value) ? "active-input-field d-flex" : "inactive-input-field"}`} style={{width:"90%"}}>
                      <input className="flex-item" value={userReport.bodyComposition.weight.value} onChange={handleChange("weight-value")} style={{ width:"50%", color: "#000000"}}  type="number" />
                      <div className="d-flex kg-lbs-switch flex-item" style={{marginRight:"0", marginBottom:"15px"}}>
                        <div className="active-switch" style={{left: userReport.bodyComposition.weight.unit == "Kg" ? "0" : "auto", right: userReport.bodyComposition.weight.unit == "Lbs" ? "0" : "auto"}} />
                        <div onClick={()=>handleChangeWeightUnit("Kg")} className="switch-container d-flex">
                          <p className="flex-item" style={{color: userReport.bodyComposition.weight.unit == "Kg" && "#ffffff"}}>KG</p>
                        </div>
                        <div onClick={()=>handleChangeWeightUnit("Lbs")} className="switch-container d-flex" style={{left: userReport.bodyComposition.weight.unit == "Lbs" ? "0" : "auto"}}>
                          <p className="flex-item" style={{color: userReport.bodyComposition.weight.unit == "Lbs" && "#ffffff"}}>LBS</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div onClick={toggleInputFields('height')} className={`${(currentElementId == 'height' || userReport.bodyComposition.height) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: (currentElementId == 'height' || userReport.bodyComposition.height) ? "1px solid var(--darkBlue)" : "", width: "48%" }}>
                    <div className="flex-item d-flex">
                      <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'height' || userReport.bodyComposition.height) ? "10px" : "14px", color: (currentElementId == 'height' || userReport.bodyComposition.height) ? "var(--darkBlue)" : "", transition: "180ms" }}>Height (ft)</p>
                    </div>
                    <input value={userReport.bodyComposition.height} onChange={handleChange("height")} className={`${(currentElementId == 'height' || userReport.bodyComposition.height) ? "active-input-field" : "inactive-input-field"}`} type="number" />
                  </div>
                </div>
                <p className="m-t-16 m-b-12 fs-16 color-dark-blue font-weight-700">Member Image</p>
                <div className="d-flex-wrap w-full">
                  {
                    userReport.bodyComposition.userReportImage.map((receipt, index)=>{
                      return(
                        <div className="report-receipt m-r-12 m-b-12 d-flex">
                          <img className="flex-item report-receipt-image" src={receipt} />
                          <div onClick={()=>handleDeleteSelectedReportImage(index)} className="delete-report-button bg-white d-flex">
                            <svg className="flex-item margin-auto svg-stroke" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M3.4375 11.875L11.5625 3.75M11.5625 11.875L3.4375 3.75" stroke="#E33A34" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                          </div>
                        </div>
                      )
                    })
                  }
                  <div className="report-receipt flex-item d-flex" style={{width: userReport.bodyComposition.userReportImage.length > 0 ? "92px" : "100%", height: userReport.bodyComposition.userReportImage.length == 0 && "126px"}}>
                    {
                      userReport.bodyComposition.userReportImage.length === 0 ? (
                        <svg className="report-input-box flex-item" width="100%" height="auto" viewBox="0 0 349 92" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect x="0.5" y="0.5" width="348" height="91" rx="10.5" fill="white" stroke="#C3C3C3" stroke-dasharray="4 4"/>
                        </svg>
                      ) : (
                        <svg className="report-input-box flex-item" width="92" height="92" viewBox="0 0 92 92" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect x="0.5" y="0.5" width="91" height="91" rx="10.5" fill="white" stroke="black" stroke-dasharray="4 4"/>
                        </svg>
                      )
                    }
                    <div className="margin-auto flex-item" style={{zIndex:"2", justifyContent:"center", textAlign:"center"}}>
                      <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.89474 0.236328H26.1053C27.4034 0.236328 28.6484 0.735387 29.5664 1.62372C30.4843 2.51205 31 3.71688 31 4.97317V25.4995C31 26.7558 30.4843 27.9606 29.5664 28.8489C28.6484 29.7373 27.4034 30.2363 26.1053 30.2363H4.89474C3.59657 30.2363 2.35158 29.7373 1.43364 28.8489C0.515694 27.9606 0 26.7558 0 25.4995V4.97317C0 3.71688 0.515694 2.51205 1.43364 1.62372C2.35158 0.735387 3.59657 0.236328 4.89474 0.236328ZM4.89474 1.81528C4.02929 1.81528 3.1993 2.14798 2.58734 2.7402C1.97537 3.33242 1.63158 4.13564 1.63158 4.97317V23.2732L8.63105 16.4837L12.71 20.4311L20.8679 12.5363L29.3684 20.7626V4.97317C29.3684 4.13564 29.0246 3.33242 28.4127 2.7402C27.8007 2.14798 26.9707 1.81528 26.1053 1.81528H4.89474ZM12.71 22.6732L8.63105 18.7258L1.63158 25.4995C1.63158 26.337 1.97537 27.1402 2.58734 27.7325C3.1993 28.3247 4.02929 28.6574 4.89474 28.6574H26.1053C26.9707 28.6574 27.8007 28.3247 28.4127 27.7325C29.0246 27.1402 29.3684 26.337 29.3684 25.4995V22.989L20.8679 14.7784L12.71 22.6732ZM8.97368 4.97317C10.0555 4.97317 11.093 5.38905 11.8579 6.12933C12.6229 6.8696 13.0526 7.87363 13.0526 8.92054C13.0526 9.96745 12.6229 10.9715 11.8579 11.7118C11.093 12.452 10.0555 12.8679 8.97368 12.8679C7.89188 12.8679 6.85438 12.452 6.08943 11.7118C5.32448 10.9715 4.89474 9.96745 4.89474 8.92054C4.89474 7.87363 5.32448 6.8696 6.08943 6.12933C6.85438 5.38905 7.89188 4.97317 8.97368 4.97317ZM8.97368 6.55212C8.3246 6.55212 7.7021 6.80165 7.24313 7.24581C6.78416 7.68998 6.52632 8.29239 6.52632 8.92054C6.52632 9.54868 6.78416 10.1511 7.24313 10.5953C7.7021 11.0394 8.3246 11.289 8.97368 11.289C9.62277 11.289 10.2453 11.0394 10.7042 10.5953C11.1632 10.1511 11.4211 9.54868 11.4211 8.92054C11.4211 8.29239 11.1632 7.68998 10.7042 7.24581C10.2453 6.80165 9.62277 6.55212 8.97368 6.55212Z" fill="#828282"/>
                      </svg>
                      {
                        userReport.bodyComposition.userReportImage.length === 0 && (
                          <p className="flex-item fs-12 m-t-8 font-weight-400 ">Upload Image</p>
                        )
                      }
                    </div>
                    <input type="file" onChange={handleFileChange} className="w-full h-full" accept=".png, .jpg, .jpeg" style={{zIndex:"3"}} />
                  </div>
                </div>
                <p className="m-t-16 m-b-12 fs-16 color-dark-blue font-weight-700">Fitness Measurement</p>
                <div className="w-full">
                  {
                    userReport.bodyComposition.fitnessMeasurement.docs && (
                      <div className="report-receipt m-r-12 m-b-12 d-flex">
                        <img className="flex-item report-receipt-image" src={userReport.bodyComposition.fitnessMeasurement.docs} />
                        <div onClick={()=>handleDeleteSelectedReportImage()} className="delete-report-button bg-white d-flex">
                          <svg className="flex-item margin-auto svg-stroke" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M3.4375 11.875L11.5625 3.75M11.5625 11.875L3.4375 3.75" stroke="#E33A34" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                        </div>
                      </div>
                    )
                  }
                  {
                    userReport.bodyComposition.fitnessMeasurement.docs == "" && (
                      <div className="report-receipt flex-item d-flex m-b-12" style={{width: userReport.bodyComposition.userReportImage.length > 0 ? "92px" : "100%", height: userReport.bodyComposition.userReportImage.length == 0 && "126px"}}>
                        <svg className="report-input-box flex-item" width="100%" height="auto" viewBox="0 0 349 92" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect x="0.5" y="0.5" width="348" height="91" rx="10.5" fill="white" stroke="#C3C3C3" stroke-dasharray="4 4"/>
                        </svg>
                        <div className="margin-auto flex-item" style={{zIndex:"2", justifyContent:"center", textAlign:"center"}}>
                          <svg className="flex-item" width="31" height="39" viewBox="0 0 31 39" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M20.5827 16.4583C18.9582 16.4583 17.4003 15.813 16.2517 14.6644C15.103 13.5157 14.4577 11.9578 14.4577 10.3333V2.16667H6.29102C5.20805 2.16667 4.16944 2.59687 3.40366 3.36265C2.63789 4.12842 2.20768 5.16703 2.20768 6.25V32.7917C2.20768 33.8746 2.63789 34.9132 3.40366 35.679C4.16944 36.4448 5.20805 36.875 6.29102 36.875H24.666C25.749 36.875 26.7876 36.4448 27.5534 35.679C28.3191 34.9132 28.7494 33.8746 28.7494 32.7917V16.4583H20.5827ZM16.4993 10.3333C16.4993 11.4163 16.9296 12.4549 17.6953 13.2207C18.4611 13.9865 19.4997 14.4167 20.5827 14.4167H27.9123L16.4993 3.00375V10.3333ZM6.29102 0.125H16.4993L30.791 14.4167V32.7917C30.791 34.4161 30.1457 35.974 28.997 37.1227C27.8484 38.2714 26.2905 38.9167 24.666 38.9167H6.29102C4.66656 38.9167 3.10865 38.2714 1.95999 37.1227C0.811326 35.974 0.166016 34.4161 0.166016 32.7917V6.25C0.166016 4.62555 0.811326 3.06763 1.95999 1.91897C3.10865 0.770311 4.66656 0.125 6.29102 0.125Z" fill="#828282"/>
                          </svg>
                          <p className="flex-item fs-12 m-t-8 font-weight-400 ">Upload Image or .pdf file</p>
                        </div>
                      </div>
                    )
                  }
                </div>
                <div className="d-flex m-t-20 m-b-12">
                  <div className="or-button bg-grey-08 d-flex flex-item m-r-12">
                    <p className="flex-item margin-auto">OR</p>
                  </div>
                  <p className="flex-item m-r-12 fs-16 font-weight-700">Add Measurements Manually</p>
                  <svg className="flex-item" width="16" height="9" viewBox="0 0 16 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15 8L8.16279 2L1 8" stroke="black" stroke-width="2" stroke-linecap="round"/>
                  </svg>
                </div>
                <div className="fitness-measurement-container d-flex space-between flex-item">
                  <div className="inner-container">
                    <div className="d-flex m-b-12">
                      <p className="margin-auto fs-16 font-weight-600">Current Measurements</p>
                    </div>
                    <div onClick={toggleInputFields('chest-current')} className={`${(currentElementId == 'chest-current' || userReport.bodyComposition.fitnessMeasurement.currentMeasurement.chest) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: (currentElementId == 'chest-current' || userReport.bodyComposition.fitnessMeasurement.currentMeasurement.chest) ? "1px solid var(--darkBlue)" : "", width: "100%" }}>
                      <div className="flex-item d-flex">
                        <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'chest-current' || userReport.bodyComposition.fitnessMeasurement.currentMeasurement.chest) ? "10px" : "14px", color: (currentElementId == 'chest-current' || userReport.bodyComposition.fitnessMeasurement.currentMeasurement.chest) ? "var(--darkBlue)" : "", transition: "180ms" }}>Chest (cm)</p>
                      </div>
                      <input value={userReport.bodyComposition.fitnessMeasurement.currentMeasurement.chest} onChange={handleChange("chest-current")} className={`${(currentElementId == 'chest-current' || userReport.bodyComposition.fitnessMeasurement.currentMeasurement.chest) ? "active-input-field" : "inactive-input-field"}`} type="number" />
                    </div>
                    <div onClick={toggleInputFields('thigh-circumference-current')} className={`${(currentElementId == 'thigh-circumference-current' || userReport.bodyComposition.fitnessMeasurement.currentMeasurement.thigh) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: (currentElementId == 'thigh-circumference-current' || userReport.bodyComposition.fitnessMeasurement.currentMeasurement.thigh) ? "1px solid var(--darkBlue)" : "", width: "100%" }}>
                      <div className="flex-item d-flex">
                        <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'thigh-circumference-current' || userReport.bodyComposition.fitnessMeasurement.currentMeasurement.thigh) ? "10px" : "14px", color: (currentElementId == 'thigh-circumference-current' || userReport.bodyComposition.fitnessMeasurement.currentMeasurement.thigh) ? "var(--darkBlue)" : "", transition: "180ms" }}>Thigh Circumference</p>
                      </div>
                      <input value={userReport.bodyComposition.fitnessMeasurement.currentMeasurement.thigh} onChange={handleChange("thigh-circumference-current")} className={`${(currentElementId == 'thigh-circumference-current' || userReport.bodyComposition.fitnessMeasurement.currentMeasurement.thigh) ? "active-input-field" : "inactive-input-field"}`} type="number" />
                    </div>
                    <div onClick={toggleInputFields('midArm-circumference-current')} className={`${(currentElementId == 'midArm-circumference-current' || userReport.bodyComposition.fitnessMeasurement.currentMeasurement.midArm) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: (currentElementId == 'midArm-circumference-current' || userReport.bodyComposition.fitnessMeasurement.currentMeasurement.midArm) ? "1px solid var(--darkBlue)" : "", width: "100%" }}>
                      <div className="flex-item d-flex">
                        <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'midArm-circumference-current' || userReport.bodyComposition.fitnessMeasurement.currentMeasurement.midArm) ? "10px" : "14px", color: (currentElementId == 'midArm-circumference-current' || userReport.bodyComposition.fitnessMeasurement.currentMeasurement.midArm) ? "var(--darkBlue)" : "", transition: "180ms" }}>Mid Arm Circumference</p>
                      </div>
                      <input value={userReport.bodyComposition.fitnessMeasurement.currentMeasurement.midArm} onChange={handleChange("midArm-circumference-current")} className={`${(currentElementId == 'midArm-circumference-current' || userReport.bodyComposition.fitnessMeasurement.currentMeasurement.midArm) ? "active-input-field" : "inactive-input-field"}`} type="number" />
                    </div>
                    <div onClick={toggleInputFields('foreArm-circumference-current')} className={`${(currentElementId == 'foreArm-circumference-current' || userReport.bodyComposition.fitnessMeasurement.currentMeasurement.foreArm) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: (currentElementId == 'foreArm-circumference-current' || userReport.bodyComposition.fitnessMeasurement.currentMeasurement.foreArm) ? "1px solid var(--darkBlue)" : "", width: "100%" }}>
                      <div className="flex-item d-flex">
                        <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'foreArm-circumference-current' || userReport.bodyComposition.fitnessMeasurement.currentMeasurement.foreArm) ? "10px" : "14px", color: (currentElementId == 'foreArm-circumference-current' || userReport.bodyComposition.fitnessMeasurement.currentMeasurement.foreArm) ? "var(--darkBlue)" : "", transition: "180ms" }}>Fore Arm Circumference</p>
                      </div>
                      <input value={userReport.bodyComposition.fitnessMeasurement.currentMeasurement.foreArm} onChange={handleChange("foreArm-circumference-current")} className={`${(currentElementId == 'foreArm-circumference-current' || userReport.bodyComposition.fitnessMeasurement.currentMeasurement.foreArm) ? "active-input-field" : "inactive-input-field"}`} type="number" />
                    </div>
                    <div onClick={toggleInputFields('upperArm-circumference-current')} className={`${(currentElementId == 'upperArm-circumference-current' || userReport.bodyComposition.fitnessMeasurement.currentMeasurement.upperArm) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: (currentElementId == 'upperArm-circumference-current' || userReport.bodyComposition.fitnessMeasurement.currentMeasurement.upperArm) ? "1px solid var(--darkBlue)" : "", width: "100%" }}>
                      <div className="flex-item d-flex">
                        <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'upperArm-circumference-current' || userReport.bodyComposition.fitnessMeasurement.currentMeasurement.upperArm) ? "10px" : "14px", color: (currentElementId == 'upperArm-circumference-current' || userReport.bodyComposition.fitnessMeasurement.currentMeasurement.upperArm) ? "var(--darkBlue)" : "", transition: "180ms" }}>Upper Arm Circumference</p>
                      </div>
                      <input value={userReport.bodyComposition.fitnessMeasurement.currentMeasurement.upperArm} onChange={handleChange("upperArm-circumference-current")} className={`${(currentElementId == 'upperArm-circumference-current' || userReport.bodyComposition.fitnessMeasurement.currentMeasurement.upperArm) ? "active-input-field" : "inactive-input-field"}`} type="number" />
                    </div>
                    <div onClick={toggleInputFields('waist-circumference-current')} className={`${(currentElementId == 'waist-circumference-current' || userReport.bodyComposition.fitnessMeasurement.currentMeasurement.waist) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: (currentElementId == 'waist-circumference-current' || userReport.bodyComposition.fitnessMeasurement.currentMeasurement.waist) ? "1px solid var(--darkBlue)" : "", width: "100%" }}>
                      <div className="flex-item d-flex">
                        <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'waist-circumference-current' || userReport.bodyComposition.fitnessMeasurement.currentMeasurement.waist) ? "10px" : "14px", color: (currentElementId == 'waist-circumference-current' || userReport.bodyComposition.fitnessMeasurement.currentMeasurement.waist) ? "var(--darkBlue)" : "", transition: "180ms" }}>Waist Circumference</p>
                      </div>
                      <input value={userReport.bodyComposition.fitnessMeasurement.currentMeasurement.waist} onChange={handleChange("waist-circumference-current")} className={`${(currentElementId == 'waist-circumference-current' || userReport.bodyComposition.fitnessMeasurement.currentMeasurement.waist) ? "active-input-field" : "inactive-input-field"}`} type="number" />
                    </div>
                  </div>
                  <div className="inner-container">
                    <div className="d-flex m-b-12">
                      <p className="margin-auto fs-16 font-weight-600">Goal</p>
                    </div>
                    <div onClick={toggleInputFields('chest-target')} className={`${(currentElementId == 'chest-target' || userReport.bodyComposition.fitnessMeasurement.goalMeasurement.chest) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: (currentElementId == 'chest-target' || userReport.bodyComposition.fitnessMeasurement.goalMeasurement.chest) ? "1px solid var(--darkBlue)" : "", width: "100%" }}>
                      <div className="flex-item d-flex">
                        <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'chest-target' || userReport.bodyComposition.fitnessMeasurement.goalMeasurement.chest) ? "10px" : "14px", color: (currentElementId == 'chest-target' || userReport.bodyComposition.fitnessMeasurement.goalMeasurement.chest) ? "var(--darkBlue)" : "", transition: "180ms" }}>Chest (cm)</p>
                      </div>
                      <input value={userReport.bodyComposition.fitnessMeasurement.goalMeasurement.chest} onChange={handleChange("chest-target")} className={`${(currentElementId == 'chest-target' || userReport.bodyComposition.fitnessMeasurement.goalMeasurement.chest) ? "active-input-field" : "inactive-input-field"}`} type="number" />
                    </div>
                    <div onClick={toggleInputFields('thigh-circumference-target')} className={`${(currentElementId == 'thigh-circumference-target' || userReport.bodyComposition.fitnessMeasurement.goalMeasurement.thigh) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: (currentElementId == 'thigh-circumference-target' || userReport.bodyComposition.fitnessMeasurement.goalMeasurement.thigh) ? "1px solid var(--darkBlue)" : "", width: "100%" }}>
                      <div className="flex-item d-flex">
                        <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'thigh-circumference-target' || userReport.bodyComposition.fitnessMeasurement.goalMeasurement.thigh) ? "10px" : "14px", color: (currentElementId == 'thigh-circumference-target' || userReport.bodyComposition.fitnessMeasurement.goalMeasurement.thigh) ? "var(--darkBlue)" : "", transition: "180ms" }}>Thigh Circumference</p>
                      </div>
                      <input value={userReport.bodyComposition.fitnessMeasurement.goalMeasurement.thigh} onChange={handleChange("thigh-circumference-target")} className={`${(currentElementId == 'thigh-circumference-target' || userReport.bodyComposition.fitnessMeasurement.goalMeasurement.thigh) ? "active-input-field" : "inactive-input-field"}`} type="number" />
                    </div>
                    <div onClick={toggleInputFields('midArm-circumference-target')} className={`${(currentElementId == 'midArm-circumference-target' || userReport.bodyComposition.fitnessMeasurement.goalMeasurement.midArm) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: (currentElementId == 'midArm-circumference-target' || userReport.bodyComposition.fitnessMeasurement.goalMeasurement.midArm) ? "1px solid var(--darkBlue)" : "", width: "100%" }}>
                      <div className="flex-item d-flex">
                        <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'midArm-circumference-target' || userReport.bodyComposition.fitnessMeasurement.goalMeasurement.midArm) ? "10px" : "14px", color: (currentElementId == 'midArm-circumference-target' || userReport.bodyComposition.fitnessMeasurement.goalMeasurement.midArm) ? "var(--darkBlue)" : "", transition: "180ms" }}>Mid Arm Circumference</p>
                      </div>
                      <input value={userReport.bodyComposition.fitnessMeasurement.goalMeasurement.midArm} onChange={handleChange("midArm-circumference-target")} className={`${(currentElementId == 'midArm-circumference-target' || userReport.bodyComposition.fitnessMeasurement.goalMeasurement.midArm) ? "active-input-field" : "inactive-input-field"}`} type="number" />
                    </div>
                    <div onClick={toggleInputFields('foreArm-circumference-target')} className={`${(currentElementId == 'foreArm-circumference-target' || userReport.bodyComposition.fitnessMeasurement.goalMeasurement.foreArm) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: (currentElementId == 'foreArm-circumference-target' || userReport.bodyComposition.fitnessMeasurement.goalMeasurement.foreArm) ? "1px solid var(--darkBlue)" : "", width: "100%" }}>
                      <div className="flex-item d-flex">
                        <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'foreArm-circumference-target' || userReport.bodyComposition.fitnessMeasurement.goalMeasurement.foreArm) ? "10px" : "14px", color: (currentElementId == 'foreArm-circumference-target' || userReport.bodyComposition.fitnessMeasurement.goalMeasurement.foreArm) ? "var(--darkBlue)" : "", transition: "180ms" }}>Fore Arm Circumference</p>
                      </div>
                      <input value={userReport.bodyComposition.fitnessMeasurement.goalMeasurement.foreArm} onChange={handleChange("foreArm-circumference-target")} className={`${(currentElementId == 'foreArm-circumference-target' || userReport.bodyComposition.fitnessMeasurement.goalMeasurement.foreArm) ? "active-input-field" : "inactive-input-field"}`} type="number" />
                    </div>
                    <div onClick={toggleInputFields('upperArm-circumference-target')} className={`${(currentElementId == 'upperArm-circumference-target' || userReport.bodyComposition.fitnessMeasurement.goalMeasurement.upperArm) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: (currentElementId == 'upperArm-circumference-target' || userReport.bodyComposition.fitnessMeasurement.goalMeasurement.upperArm) ? "1px solid var(--darkBlue)" : "", width: "100%" }}>
                      <div className="flex-item d-flex">
                        <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'upperArm-circumference-target' || userReport.bodyComposition.fitnessMeasurement.goalMeasurement.upperArm) ? "10px" : "14px", color: (currentElementId == 'upperArm-circumference-target' || userReport.bodyComposition.fitnessMeasurement.goalMeasurement.upperArm) ? "var(--darkBlue)" : "", transition: "180ms" }}>Upper Arm Circumference</p>
                      </div>
                      <input value={userReport.bodyComposition.fitnessMeasurement.goalMeasurement.upperArm} onChange={handleChange("upperArm-circumference-target")} className={`${(currentElementId == 'upperArm-circumference-target' || userReport.bodyComposition.fitnessMeasurement.goalMeasurement.upperArm) ? "active-input-field" : "inactive-input-field"}`} type="number" />
                    </div>
                    <div onClick={toggleInputFields('waist-circumference-target')} className={`${(currentElementId == 'waist-circumference-target' || userReport.bodyComposition.fitnessMeasurement.goalMeasurement.waist) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: (currentElementId == 'waist-circumference-target' || userReport.bodyComposition.fitnessMeasurement.goalMeasurement.waist) ? "1px solid var(--darkBlue)" : "", width: "100%" }}>
                      <div className="flex-item d-flex">
                        <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'waist-circumference-target' || userReport.bodyComposition.fitnessMeasurement.goalMeasurement.waist) ? "10px" : "14px", color: (currentElementId == 'waist-circumference-target' || userReport.bodyComposition.fitnessMeasurement.goalMeasurement.waist) ? "var(--darkBlue)" : "", transition: "180ms" }}>Waist Circumference</p>
                      </div>
                      <input value={userReport.bodyComposition.fitnessMeasurement.goalMeasurement.waist} onChange={handleChange("waist-circumference-target")} className={`${(currentElementId == 'waist-circumference-target' || userReport.bodyComposition.fitnessMeasurement.goalMeasurement.waist) ? "active-input-field" : "inactive-input-field"}`} type="number" />
                    </div>
                  </div>
                </div>
              </div>
            )
          }

          {
            props.appointmentDetails.extendedProps.reportType == "Fitness Test" && (
              <div className="w-full">
                {
                  userReport.fitnessTest.fitnessPlanner.tests.length > 0 ? (
                    <div className="m-b-8 m-t-12 w-full">
                      <div onClick={()=>handleCancelFitnessPlanner()} className="d-flex m-b-30 cursor-pointer">
                        <svg className="flex-item m-r-8" width="19" height="16" viewBox="0 0 19 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M17.0312 9C17.5835 9 18.0312 8.55228 18.0312 8C18.0312 7.44772 17.5835 7 17.0312 7V9ZM0.292923 7.29289C-0.0976009 7.68342 -0.0976009 8.31658 0.292923 8.70711L6.65689 15.0711C7.04741 15.4616 7.68057 15.4616 8.0711 15.0711C8.46162 14.6805 8.46162 14.0474 8.0711 13.6569L2.41424 8L8.0711 2.34315C8.46162 1.95262 8.46162 1.31946 8.0711 0.928932C7.68057 0.538408 7.04741 0.538408 6.65689 0.928932L0.292923 7.29289ZM17.0312 7L1.00003 7V9L17.0312 9V7Z" fill="#9a9a9a"/>
                        </svg>
                        <p className="flex-item m-r-8 font-weight-700 color-dark-blue fs-18">{userReport.fitnessTest.fitnessPlanner.plannerName}</p>
                      </div>
                      {
                        userReport.fitnessTest.fitnessPlanner.tests.map((exercise, index) => {
                          return (
                            <div className="w-full">
                              <div className="space-between w-full d-flex m-b-8 flex-item">
                                <div className="flex-item">
                                  <p className="fs-16 font-weight-600" style={{lineHeight:"14px"}}>{exercise.name}</p>
                                  <p className="fs-12">Unit - {exercise.unit}</p>
                                </div>
                                <div className="flex-item d-flex">
                                  {
                                    exercise.unit == "Weight" && (
                                      <div className="d-flex kg-lbs-switch cursor-pointer flex-item">
                                        <div className="active-switch" style={{left: userReport.bodyComposition.weight.unit == "Kg" ? "0" : "auto", right: userReport.bodyComposition.weight.unit == "Lbs" ? "0" : "auto"}} />
                                        <div onClick={()=>handleChangeWeightUnit("Kg")} className="switch-container d-flex">
                                          <p className="flex-item" style={{color: userReport.bodyComposition.weight.unit == "Kg" && "#ffffff"}}>KG</p>
                                        </div>
                                        <div onClick={()=>handleChangeWeightUnit("Lbs")} className="switch-container d-flex" style={{left: userReport.bodyComposition.weight.unit == "Lbs" ? "0" : "auto"}}>
                                          <p className="flex-item" style={{color: userReport.bodyComposition.weight.unit == "Lbs" && "#ffffff"}}>LBS</p>
                                        </div>
                                      </div>
                                    )
                                  }
                                  <svg className="flex-item" width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9.33334 0C7.48738 0 5.68287 0.54739 4.14802 1.57295C2.61316 2.59851 1.41688 4.05618 0.710462 5.76162C0.00404396 7.46707 -0.180787 9.34369 0.179342 11.1542C0.53947 12.9647 1.42838 14.6277 2.73367 15.933C4.03896 17.2383 5.70201 18.1272 7.5125 18.4873C9.32298 18.8475 11.1996 18.6626 12.9051 17.9562C14.6105 17.2498 16.0682 16.0535 17.0937 14.5187C18.1193 12.9838 18.6667 11.1793 18.6667 9.33333C18.6667 6.85798 17.6833 4.48401 15.933 2.73367C14.1827 0.983331 11.8087 0 9.33334 0ZM1.16667 9.33333C1.16723 7.37093 1.87793 5.47503 3.1675 3.99583L14.6708 15.4992C13.4878 16.5208 12.0364 17.1814 10.489 17.4026C8.94163 17.6238 7.36327 17.3963 5.94137 16.7471C4.51946 16.0978 3.31374 15.0542 2.46738 13.74C1.62102 12.4259 1.16958 10.8964 1.16667 9.33333ZM15.4992 14.6708L3.99584 3.1675C5.56113 1.85963 7.5592 1.18486 9.59694 1.27597C11.6347 1.36707 13.5646 2.21744 15.0069 3.65978C16.4492 5.10212 17.2996 7.032 17.3907 9.06974C17.4818 11.1075 16.807 13.1055 15.4992 14.6708Z" fill="#B0B0B0"/>
                                  </svg>
                                </div>
                              </div>
                              <div className="space-between w-full d-flex flex-item m-b-12">
                                <div onClick={toggleInputFields(`achievement-${index}`, index)} className={`${(currentElementId == `achievement-${index}` || exercise.achievement) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: (currentElementId == `achievement-${index}` || exercise.achievement) ? "1px solid var(--darkBlue)" : "", width: "48%" }}>
                                  <div className="flex-item d-flex">
                                    <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == `achievement-${index}` || exercise.achievement) ? "10px" : "14px", color: (currentElementId == `achievement-${index}` || exercise.achievement) ? "var(--darkBlue)" : "", transition: "180ms" }}>Achievement</p>
                                  </div>
                                  <input value={exercise.achievement} onChange={handleChange("achievement", index)} className={`${(currentElementId == `achievement-${index}` || exercise.achievement) ? "active-input-field" : "inactive-input-field"}`} type="number" />
                                </div>
                                <div onClick={toggleInputFields(`goal-${index}`, index)} className={`${(currentElementId == `goal-${index}` || exercise.goal) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: (currentElementId == `goal-${index}` || exercise.goal) ? "1px solid var(--darkBlue)" : "", width: "48%" }}>
                                  <div className="flex-item d-flex">
                                    <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == `goal-${index}` || exercise.goal) ? "10px" : "14px", color: (currentElementId == `goal-${index}` || exercise.goal) ? "var(--darkBlue)" : "", transition: "180ms" }}>Goal</p>
                                  </div>
                                  <input value={exercise.goal} onChange={handleChange("goal", index)} className={`${(currentElementId == `goal-${index}` || exercise.goal) ? "active-input-field" : "inactive-input-field"}`} type="number" />
                                </div>
                              </div>
                            </div>
                          )
                        })
                      }
                    </div>
                  ) : (
                    <div className="m-b-8 m-t-12">
                      <p className="flex-item m-r-8 font-weight-700 color-dark-blue fs-16 m-b-8">Fitness Test</p>
                      <div className="w-full">
                        {
                          userReport.bodyComposition.fitnessMeasurement.docs && (
                            <div className="report-receipt m-r-12 m-b-12 d-flex">
                              <img className="flex-item report-receipt-image" src={userReport.bodyComposition.fitnessMeasurement.docs} />
                              <div onClick={()=>handleDeleteSelectedReportImage()} className="delete-report-button bg-white d-flex">
                                <svg className="flex-item margin-auto svg-stroke" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M3.4375 11.875L11.5625 3.75M11.5625 11.875L3.4375 3.75" stroke="#E33A34" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                              </div>
                            </div>
                          )
                        }
                        {
                          userReport.bodyComposition.fitnessMeasurement.docs == "" && (
                            <div className="report-receipt flex-item d-flex m-b-12" style={{width: userReport.bodyComposition.userReportImage.length > 0 ? "92px" : "100%", height: userReport.bodyComposition.userReportImage.length == 0 && "126px"}}>
                              <svg className="report-input-box flex-item" width="100%" height="auto" viewBox="0 0 349 92" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="0.5" y="0.5" width="348" height="91" rx="10.5" fill="white" stroke="#C3C3C3" stroke-dasharray="4 4"/>
                              </svg>
                              <div className="margin-auto flex-item" style={{zIndex:"2", justifyContent:"center", textAlign:"center"}}>
                                <svg className="flex-item" width="31" height="39" viewBox="0 0 31 39" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M20.5827 16.4583C18.9582 16.4583 17.4003 15.813 16.2517 14.6644C15.103 13.5157 14.4577 11.9578 14.4577 10.3333V2.16667H6.29102C5.20805 2.16667 4.16944 2.59687 3.40366 3.36265C2.63789 4.12842 2.20768 5.16703 2.20768 6.25V32.7917C2.20768 33.8746 2.63789 34.9132 3.40366 35.679C4.16944 36.4448 5.20805 36.875 6.29102 36.875H24.666C25.749 36.875 26.7876 36.4448 27.5534 35.679C28.3191 34.9132 28.7494 33.8746 28.7494 32.7917V16.4583H20.5827ZM16.4993 10.3333C16.4993 11.4163 16.9296 12.4549 17.6953 13.2207C18.4611 13.9865 19.4997 14.4167 20.5827 14.4167H27.9123L16.4993 3.00375V10.3333ZM6.29102 0.125H16.4993L30.791 14.4167V32.7917C30.791 34.4161 30.1457 35.974 28.997 37.1227C27.8484 38.2714 26.2905 38.9167 24.666 38.9167H6.29102C4.66656 38.9167 3.10865 38.2714 1.95999 37.1227C0.811326 35.974 0.166016 34.4161 0.166016 32.7917V6.25C0.166016 4.62555 0.811326 3.06763 1.95999 1.91897C3.10865 0.770311 4.66656 0.125 6.29102 0.125Z" fill="#828282"/>
                                </svg>
                                <p className="flex-item fs-12 m-t-8 font-weight-400 ">Upload Image or .pdf file</p>
                              </div>
                            </div>
                          )
                        }
                      </div>
                      <div className="d-flex m-t-20 m-b-30">
                        <div className="or-button bg-grey-08 d-flex flex-item m-r-12">
                          <p className="flex-item margin-auto">OR</p>
                        </div>
                        <p className="flex-item m-r-12 fs-16 font-weight-700">Select Fitness Planner</p>
                        <svg className="flex-item" width="16" height="9" viewBox="0 0 16 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M15 8L8.16279 2L1 8" stroke="black" stroke-width="2" stroke-linecap="round"/>
                        </svg>
                      </div>
                      {
                        fitnessPlanners.map((planner, index) => {
                          return(
                            <div onClick={()=>handleFitnessPlanner(index)} className="w-full cursor-pointer m-b-20">
                              <div className="d-flex m-b-6">
                                <input className="m-r-8" type="radio" name="fitness-planner" checked={currentFitnessPlannerIndex == index} style={{alignSelf:"flex-start", width:"20px", height:"20px"}}/>
                                <div className="flex-item">
                                  <p className="flex-item fs-16 font-weight-600" style={{lineHeight:"16px"}}>{planner.name}</p>
                                  <p className="flex-item fs-12">{planner.exercisesTest.length} Exercises</p>
                                </div>
                              </div>
                              {
                                currentFitnessPlannerIndex == index && ( 
                                  <div className="w-full">
                                    <div className="fitness-planner-exercise-container bg-white">
                                      {
                                        planner.exercisesTest.map((exercise, index) => {
                                          return(
                                            <div className="flex-item" style={{marginBottom: planner.exercisesTest.length != index + 1 && "12px", paddingBottom: planner.exercisesTest.length != index + 1 && "12px", borderBottom: planner.exercisesTest.length != index + 1 && "1px solid #E5E5E5"}}>
                                              <p className="fs-14 font-weight-600" style={{lineHeight:"14px"}}>{exercise.name}</p>
                                              <p className="fs-12">Unit - {exercise.unit}</p>
                                            </div>
                                          )
                                        })
                                      }
                                    </div>
                                    <div onClick={()=>handleFitnessTakeTest(planner)} className="global-button-container global-button-container-active d-flex flex-item w-full m-t-12 m-b-30" style={{height:"40px", borderRadius:"20px"}}>
                                      <p className="flex-item fs-14 color-white">Take Test</p>
                                    </div>
                                  </div>
                                )
                              }
                            </div>
                          )
                        })
                      }
                    </div>
                 )
                }
              </div>
            )
          }

          {
            props.appointmentDetails.extendedProps.reportType == "Nutrition" && (
              <div className="w-full">
                <p className="fs-16 font-weight-700 color-dark-blue m-b-12">Nutrition Content <span className="color-red">(Current)</span></p>
                <div className="d-flex w-full m-b-8">
                  <div className="nutrition-content-view d-flex space-between m-b-8" style={{width:"100%", padding: 0}}>
                    <div className="content-preview-img flex-item">
                      <img className="flex-item w-full h-full" src={`https://picsum.photos/200/300`} alt="content preview image" />
                    </div>
                    <div className="text-container" style={{padding:"12px 0px"}}>
                      <div className="d-flex flex-item">
                        <p className="flex-item fs-16 color-black font-weight-600 m-r-8" style={{lineHeight:"16px"}}>Content Name</p>
                      </div>
                      <p className="flex-item fs-12 color-grey-04 m-t-8" style={{lineHeight:"16px"}}>Content Description</p>
                    </div>
                  </div>
                </div>
                <div className="dashboard-data-saperator flex-item" style={{background:'#ffffff', marginTop:"0"}} />
                <p className="fs-16 font-weight-700 color-dark-blue m-b-8">Assign New</p>
                <div className="w-full m-b-20">
                  {[1,2,3,4].map(data => {
                    return[
                      <div className="nutrition-content-view d-flex space-between m-b-12" style={{width:"100%", padding: 0}}>
                        <div className="content-preview-img flex-item" style={{position:"relative"}}>
                          <input type="radio" name="nutrition" style={{position:"absolute", width:"20px", height:"20px", top:"0px", left:"0px", zIndex:"2", margin: "8px 0 0 8px"}}/>
                          <img className="flex-item w-full h-full" src={`https://picsum.photos/200/300`} alt="content preview image" />
                        </div>
                        <div className="text-container" style={{padding:"12px 0px"}}>
                          <div className="d-flex flex-item">
                            <p className="flex-item fs-16 color-black font-weight-600 m-r-8" style={{lineHeight:"16px"}}>Content Name</p>
                          </div>
                          <p className="flex-item fs-12 color-grey-04 m-t-8" style={{lineHeight:"16px"}}>For a Paneer & Egg Salad, mix boiled eggs (chopped) and paneer cubes with fresh veggies like cucumber, tomatoes, and lettuce. Add a simple dressing of olive oil, lemon juice, salt, and pepper more</p>
                        </div>
                      </div>,
                      <div className="dashboard-data-saperator flex-item" style={{background:'#ffffff', marginTop:"0"}} />
                    ]
                  })}
                </div>
              </div>
            )
          } */}

        </div>
        <div className="d-flex w-full m-t-12 p-l-12 p-r-12">
          <div onClick={isButtonLock?null:MarkAppointment} className={`global-button-container ${isButtonLock?"global-button-container-inactive":"global-button-container-active"} d-flex flex-item w-full`} style={{height:"40px", borderRadius:"20px",pointerEvents:isButtonLock?'none':'auto'}}>
            <p className="flex-item fs-14 color-white">Mark Report</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MarkAppointmentReport;